import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";

export function CartActions({ cart, hasDraft, onSaveDraft, onRestoreDraft, onOpenPayment, submitting }) {
  const empty = cart.length === 0;
  return (
    <>
      <div className="grid grid-cols-2 gap-1.5">
        <Button type="button" variant="outline" onClick={onSaveDraft} disabled={empty} className="h-9 rounded-sm" data-testid="btn-save-draft">
          <Save className="w-3.5 h-3.5 mr-1" aria-hidden="true" />Lưu nháp
        </Button>
        {hasDraft && empty
          ? <Button type="button" variant="outline" onClick={onRestoreDraft} className="h-9 rounded-sm" data-testid="btn-restore-draft">Khôi phục nháp</Button>
          : <div />}
      </div>
      <Button type="button" onClick={onOpenPayment} disabled={empty || submitting}
        className="h-11 w-full bg-emerald-800 hover:bg-emerald-900 rounded-sm" data-testid="btn-pay-open">
        Thanh toán (F9)
      </Button>
    </>
  );
}
